module.exports = __webpack_public_path__ + "img/08_NSC_Groesse_iPad_P.defaabf4.jpg";